/**
 * 알림 켜기/끄기 — 변경고시 반영·★ 세번 변경을 휴대폰(또는 PC 브라우저)으로 받는다.
 * variant="row": 모바일 더보기 시트의 한 줄 · variant="card": 내 계정 설정의 칸.
 */
import React, { useEffect, useState } from "react";
import { Bell, BellOff } from "lucide-react";
import { disablePush, enablePush, pushState, sendTestPush } from "../audit/pushApi";

export default function PushToggle({ variant = "card", rowStyle, sectionStyle, titleStyle }) {
  const [state, setState] = useState("loading");
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState("");

  useEffect(() => {
    let alive = true;
    pushState().then((s) => alive && setState(s)).catch(() => alive && setState("off"));
    return () => { alive = false; };
  }, []);

  const toggle = async () => {
    setBusy(true);
    setMsg("");
    try {
      if (state === "on") setState(await disablePush());
      else {
        setState(await enablePush());
        setMsg("알림을 켰습니다.");
      }
    } catch (e) {
      setMsg(e.message);
    } finally {
      setBusy(false);
    }
  };

  const test = async () => {
    setBusy(true);
    setMsg("");
    try {
      const r = await sendTestPush();
      setMsg(r.sent > 0 ? "시험 알림을 보냈습니다. 몇 초 안에 도착합니다." : "보낼 기기가 없습니다. 알림을 다시 켜 주세요.");
    } catch (e) {
      setMsg(e.message);
    } finally {
      setBusy(false);
    }
  };

  const desc = {
    loading: "확인하는 중…",
    install: "아이폰은 홈 화면에 설치한 앱에서 알림을 켤 수 있습니다.",
    unsupported: "이 브라우저는 알림을 지원하지 않습니다.",
    denied: "알림이 막혀 있습니다. 휴대폰·브라우저 설정에서 loginHS 알림을 허용해 주세요.",
    on: "변경고시 반영과 ★ 세번 변경을 알려 드립니다.",
    off: "변경고시 반영과 ★ 세번 변경을 알림으로 받습니다.",
  }[state];

  if (variant === "row") {
    if (state === "unsupported") return null;
    const on = state === "on";
    return (
      <>
        <button type="button" style={rowStyle} onClick={state === "install" ? () => { window.location.href = "/?page=install"; } : toggle}
          disabled={busy || state === "loading" || state === "denied"} data-testid="push-row">
          {on ? <BellOff size={18} strokeWidth={1.6} /> : <Bell size={18} strokeWidth={1.6} />}
          {state === "install" ? "알림 받기 — 먼저 홈 화면에 설치" : on ? "알림 끄기" : "알림 켜기"}
          {busy && <span style={{ fontSize: 12, color: "#6b7280" }}>…</span>}
        </button>
        {msg && <div style={{ padding: "0 18px 8px 48px", fontSize: 12.5, color: "#4b5563" }}>{msg}</div>}
      </>
    );
  }

  return (
    <section style={sectionStyle} data-testid="push-card">
      <h3 style={titleStyle}>알림</h3>
      <p style={{ fontSize: 13, color: "#4b5563", margin: "6px 0 10px", lineHeight: 1.6 }}>{desc}</p>
      <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
        {(state === "on" || state === "off") && (
          <button type="button" onClick={toggle} disabled={busy} style={btn(state !== "on")}>
            {state === "on" ? "이 기기 알림 끄기" : "이 기기에서 알림 켜기"}
          </button>
        )}
        {state === "install" && <a href="/?page=install" style={{ ...btn(true), textDecoration: "none" }}>설치 안내 보기</a>}
        {state === "on" && <button type="button" onClick={test} disabled={busy} style={btn(false)}>시험 알림 보내기</button>}
      </div>
      {msg && <div style={{ marginTop: 8, fontSize: 12.5, color: "#4b5563" }}>{msg}</div>}
    </section>
  );
}

const btn = (primary) => ({
  height: 34, padding: "0 14px", borderRadius: 8, fontSize: 13, fontWeight: 700, cursor: "pointer", fontFamily: "inherit",
  border: `1px solid ${primary ? "#0b0a34" : "#d1d5db"}`, background: primary ? "#0b0a34" : "#fff", color: primary ? "#fff" : "#1f2937",
  display: "inline-flex", alignItems: "center",
});
